import React, { Component } from 'react';
import { sendJson } from '../../backend/Backend';
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from  "react-datepicker";
import de from 'date-fns/locale/de';
import { translate } from "react-i18next";
import '../../css/style.css';
import '../Home.css';
import PublicEventAddPages from './PublicEventAddPages';

registerLocale('de', de)

function emptyEvent() {
    return {
      name:'',
      comment:'',
      startDate: new Date().getTime(),
      endDate: new Date().getTime(),
      eventType:'',
      status:'',
      modificationUser:'react'
    };
  }


class PublicEventAddParent extends Component {

    constructor(props) {
        super(props);

        this.onEventAdd = this.onEventAdd.bind(this);
        this.onEventInputChange = this.onEventInputChange.bind(this);
        this.onEventEndDateChange = this.onEventEndDateChange.bind(this);
        this.onEventStartDateChange = this.onEventStartDateChange.bind(this);

        this.state = {
            validated: false ,
            event: emptyEvent()
        };
    }

    async componentDidMount() {
        /*const response = await fetch(getURL (`events/list/test`));
        const json = await response.json();
        {json.map((event) => {
            this.props.onAdd(event);
        })}*/
      }

    onEventAdd() {
        sendJson('post', 'events/save', this.state.event).then(
            received => {
              //this.props.onAdd(received);
              console.log("Saved Event: "+received.id +" start:"+received.startDate); 
            });
    }

    onEventInputChange(obj) {
        const { name: fieldName, value: fieldValue } = obj.target;
        const { event } = this.state;

        const newEvent = {
        ...event,
        [fieldName]: fieldValue
        };

        this.setState({
        event: newEvent
        });
  }

  onEventStartDateChange(obj) {
      const { event } = this.state;

        const newEvent = {
        ...event,
        startDate: obj.getTime()
        };

        this.setState({
        event: newEvent
        });
  }

    onEventEndDateChange(obj) {
        const { event } = this.state;

        const newEvent = {
        ...event,
        endDate: obj.getTime()
        };

        this.setState({
        event: newEvent
        });
    }

    render() {
      return (<PublicEventAddPages />);
    }

}


export default translate("translations")(PublicEventAddParent);
